import { Theme } from '@constants';
export const LAYOUT_OFFSET = Theme.px(700);

export const continueWatchingCategoryData = {
  name: 'Continue Watching',
  custom_fields: [
    {
      field_title: 'type',
      field_value: 'continueWatching',
    },
  ],
};
